import * as _utils2 from "@near-js/utils";
var _utils = _utils2;
try {
  if ("default" in _utils2) _utils = _utils2.default;
} catch (e) {}
var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ServerError = exports.getErrorTypeFromErrorMessage = exports.formatError = exports.parseResultError = exports.parseRpcError = void 0;
var utils_1 = _utils;
Object.defineProperty(exports, "parseRpcError", {
  enumerable: true,
  get: function () {
    return utils_1.parseRpcError;
  }
});
Object.defineProperty(exports, "parseResultError", {
  enumerable: true,
  get: function () {
    return utils_1.parseResultError;
  }
});
Object.defineProperty(exports, "formatError", {
  enumerable: true,
  get: function () {
    return utils_1.formatError;
  }
});
Object.defineProperty(exports, "getErrorTypeFromErrorMessage", {
  enumerable: true,
  get: function () {
    return utils_1.getErrorTypeFromErrorMessage;
  }
});
Object.defineProperty(exports, "ServerError", {
  enumerable: true,
  get: function () {
    return utils_1.ServerError;
  }
});
export default exports;
export const __esModule = exports.__esModule,
  ServerError = exports.ServerError,
  getErrorTypeFromErrorMessage = exports.getErrorTypeFromErrorMessage,
  formatError = exports.formatError,
  parseResultError = exports.parseResultError,
  parseRpcError = exports.parseRpcError;